import enLang from "./entries/en-US";
import arLang from "./entries/ar_SA";

const AppLocale = {
  en: enLang,
  ar: arLang,
};

export default AppLocale;
